import type {
  Selection,
  ToteSelection,
  FobPropositionSelection,
  RacingBetType,
  BettingType,
} from '@mobi/betslip/types'
import { isNoveltyBetType } from '@mobi/betslip/helpers/typeGuards'

export function getMarketTitle(selection: Selection) {
  if ((selection as ToteSelection).betType) {
    return (selection as ToteSelection).betType
  }
  if ((selection as FobPropositionSelection).marketCode) {
    return (selection as FobPropositionSelection).marketName
  }
  const defaultVal: Extract<RacingBetType, 'Win & Place'> = 'Win & Place'
  return defaultVal
}

export function getFixedOrToteDisplay(selection: Selection, bettingType: BettingType) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (isNoveltyBetType((selection as any).betType)) {
    return ''
  }
  if (bettingType === 'fixed-odds-racing' && !(selection as FobPropositionSelection).marketCode) {
    return 'Fixed'
  }
  if (bettingType === 'tote-racing') {
    return 'Tote'
  }
  return ''
}
